import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="w-full py-16 px-4" data-id="element-56">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto bg-forest text-cream p-8 md:p-12 rounded-2xl relative overflow-hidden shadow-lg" data-id="element-57">
        <Quote className="absolute top-4 left-4 w-24 h-24 text-cream/10 transform -rotate-12" data-id="element-58" />

        <div className="relative z-10" data-id="element-59">
          <blockquote className="font-serif text-xl md:text-2xl leading-relaxed italic mb-6" data-id="element-60">
            "Als Tierärztin sehe ich täglich Hunde mit Verdauungsproblemen.
            Natürliche Ballaststoffe und Präbiotika können die Darmflora
            nachhaltig stabilisieren – das ist wissenschaftlich belegt."
          </blockquote>

          <div className="flex items-center gap-4" data-id="element-61">
            <div className="w-12 h-12 bg-cream/20 rounded-full flex items-center justify-center" data-id="element-62">
              <span className="font-serif font-bold text-xl" data-id="element-63">NS</span>
            </div>
            <div data-id="element-64">
              <cite className="font-serif font-semibold text-lg not-italic block" data-id="element-65">
                Dr. Nane Schomburg
              </cite>
              <span className="font-serif text-cream/80 text-sm" data-id="element-66">
                Tierärztin
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}